import { useEffect, useState } from 'react'
import { Box, Card, Typography, useMediaQuery } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { CardFiltration, FiltrationAutocomplete, FiltrationText } from './style'
import { FormBlock } from '../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { PureLightTheme } from '../../../styles/theme'
import { TEXT_FILTER_DEBOUNCE_MS } from '../../../consts/filtration'

const normalizeStringFilter = (value: unknown): string | undefined => {
  const normalized = String(value ?? '').trim()
  if (!normalized || normalized === 'all') {
    return undefined
  }
  return normalized
}

export const TeamsFiltration = () => {
  const isTablet = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const { watch } = useFormContext()
  const [searchParams, setSearchParams] = useSearchParams()
  const search = watch('search')
  const regionTeam = watch('regionTeam')
  const [debouncedSearch, setDebouncedSearch] = useState(search)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedSearch(search)
    }, TEXT_FILTER_DEBOUNCE_MS)

    return () => window.clearTimeout(timeoutId)
  }, [search])

  useEffect(() => {
    const nextParams = new URLSearchParams(searchParams)
    const normalizedQuery = normalizeStringFilter(debouncedSearch)
    const normalizedRegion = normalizeStringFilter(regionTeam)

    const syncParam = (key: string, value?: string) => {
      if (value) {
        nextParams.set(key, value)
      } else {
        nextParams.delete(key)
      }
    }

    syncParam('query', normalizedQuery)
    syncParam('region', normalizedRegion)

    if (nextParams.toString() !== searchParams.toString()) {
      setSearchParams(nextParams, { replace: true })
    }
  }, [debouncedSearch, regionTeam, searchParams, setSearchParams])

  return (
    <Card variant='primaryCard' sx={CardFiltration}>
      {!isTablet && (
        <Box mb={{ md: 2.5 }}>
          <FormBlock formFieldConfig={getFormConfig('search')} />
        </Box>
      )}

      <Typography variant='h4' sx={FiltrationText}>Регион:</Typography>
      <Box sx={FiltrationAutocomplete}>
        <FormBlock formFieldConfig={getFormConfig('region')} />
      </Box>
    </Card>
  )
}
